// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"70":"70b6b8c8","811":"64bd9dec"}[chunkId] + ".js";
};